import(/* webpackMode: "eager" */ "/opt/build/repo/animations/FadeUpOnVisible.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/ledventure-enigma01.webp");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/ledventure-enigma02.webp");
